import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SepticaContainer from './septica/SepticaContainer';
import SquareGame from './game1/container.game1';
import { Quiz } from './Quiz';
import Game2 from './game1/container.game2';
import Game3 from './game1/container.game3';
import Quiz2 from './quiz2';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Game3 />} />
        <Route path="/1" element={<SepticaContainer />} />
        <Route path="/2" element={<Quiz />} />
        <Route path="/3" element={<Game2 />} />
        <Route path="/4" element={<SquareGame />} />
        <Route path="/5" element={<Quiz2 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
